var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.59944 13.9722C3.59944 12.6039 4.71523 11.4669 6.10475 11.4669C6.1889 11.4669 6.25219 11.4879 6.33634 11.4879L6.44163 11.5089C6.86265 11.5721 7.24167 11.2983 7.32584 10.8984C7.81002 8.87731 9.62055 7.46681 11.7048 7.46681C11.8522 7.46681 11.9995 7.48781 12.147 7.48781L12.8839 5.951C12.505 5.86685 12.105 5.82471 11.705 5.82471C9.11555 5.82471 6.84182 7.44581 5.95761 9.82473C3.7682 9.90888 1.99969 11.7194 1.99969 13.9511C1.99969 16.2248 3.85237 18.0774 6.12603 18.0774H7.09453L7.87344 16.4563H6.12606C4.71527 16.4775 3.59948 15.3405 3.59948 13.9722L3.59944 13.9722Z",
    fill: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8416 8.68818C16.5048 8.18287 16.1047 7.71967 15.6627 7.3408L16.7154 5.15139C16.9048 4.75135 16.7364 4.26717 16.3365 4.07773C15.9364 3.88829 15.4523 4.05674 15.2628 4.45661L8.04172 19.5725C7.85228 19.9725 8.02072 20.4567 8.4206 20.6461C8.52589 20.7093 8.65219 20.7303 8.77848 20.7303C9.07321 20.7303 9.36795 20.5618 9.5154 20.2671L10.547 18.0987H17.2839C19.8734 18.0987 21.9997 15.9934 21.9997 13.3829C21.9786 10.6463 19.6207 8.4148 16.8418 8.68811L16.8416 8.68818ZM17.2627 16.4777H11.3047L14.9258 8.87765C15.2205 9.19338 15.4943 9.55141 15.6837 9.9513C15.8521 10.2882 16.21 10.4566 16.5889 10.3723C16.8205 10.3092 17.052 10.2882 17.2627 10.2882C18.9679 10.2882 20.3574 11.6777 20.3574 13.3829C20.3574 15.0882 18.968 16.4777 17.2627 16.4777V16.4777Z",
    fill: "#AEAEAE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudOff);
export default __webpack_public_path__ + "static/media/cloud-off.f7bd5638c331856b8c34e3a9d621051f.svg";
export { ForwardRef as ReactComponent };